module.exports = __webpack_public_path__ + "70223e8cc7cdf69db3766612f18bbac8.svg";